<template>
  <div>
    <EthiopianDatePicker
      v-if="calendarSystem === CalendarSystem.ETHIOPIC"
      :model-value="startDateEthiopian"
      @update:modelValue="onEthiopianDateSelected"
    />
    <input
      v-else
      type="date"
      :value="modelValue"
      :disabled="disabled"
      class="form-control shadow-none"
      @input="onGregorianDateInput"
    />
  </div>
</template>

<script>
import { toGregorian, toEthiopian } from 'ethiopian-calendar-new';
import EthiopianDatePicker from '@/components/date/Ethiopian_Date_Picker.vue';
import { CalendarSystem } from '@/utils/enums';

export default {
  name: 'CalendarDatePicker',
  components: {
    EthiopianDatePicker,
  },
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      CalendarSystem,
      startDateEthiopian: null,
    };
  },
  computed: {
    calendarSystem() {
      const account = this.$store.getters.account?.data;
      return account?.organization?.calendarSystem || CalendarSystem.GREGORIAN;
    },
  },
  watch: {
    modelValue: {
      handler(val) {
        if (this.calendarSystem === CalendarSystem.ETHIOPIC && val) {
          const [y, m, d] = val.split('-').map(Number);
          if (y && m && d) {
            const eth = toEthiopian(y, m, d);
            this.startDateEthiopian = { year: eth.year, month: eth.month, day: eth.day };
          } else {
            this.startDateEthiopian = null;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    onEthiopianDateSelected(ethiopian) {
      this.startDateEthiopian = ethiopian;
      if (ethiopian && ethiopian.year && ethiopian.month && ethiopian.day) {
        const gregorian = toGregorian(ethiopian.year, ethiopian.month, ethiopian.day);
        const value = `${gregorian.year}-${String(gregorian.month).padStart(2, '0')}-${String(gregorian.day).padStart(2, '0')}`;
        this.$emit('update:modelValue', value);
      } else {
        this.$emit('update:modelValue', null);
      }
    },
    onGregorianDateInput(e) {
      const value = e.target.value || null;
      this.$emit('update:modelValue', value);
    },
  },
};
</script>
